export enum OtherBenefitType {
    UNEMPLOYMENT = "Unemployment",
    SOCIAL_SECURITY_DISABILITY = "Social Security (disability)",
    WORKERS_COMPENSATION = "Workers' compensation",
    STATE_DISABILITY = "State disability",
    PENSION = "Pension",
    SOCIAL_SECURITY_EARLY_RETIREMENT = "Social Security (early retirement)",
    SOCIAL_SECURITY_WIDOWS = "Social Security (widows)",
    SOCIAL_SECURITY_RETIREMENT = "Social Security (retirement)",
}